<template>
  <div id="modalCupom" :class="{'modal-cupom': !componente}" v-show="opened">
    <div class="modal-cupom-content">
      <div class="py-4 py-md-3 bg-white shadow-sm" v-if="!componente">
        <div class="container text-center position-relative">
          <a href="javascript:" @click="closeModal" class="btn btn-outline-light position-absolute" style="left: 12px; top: -7px; border-radius: 50%" aria-label="Voltar">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <h1 class="h6 font-weight-bold m-auto">Cupons</h1>
        </div>
      </div>
      <loading v-if="load" :fullscrean="true" text="Buscando cupons.."/>
      <div :class="{'mt-3 container': !componente}" v-show="!load">
        <form @submit.prevent="getCupons()" v-if="!readonly">
          <div>
            <label class="font-weight-bold mb-0 small" for="cupom">Código do seu cupom:</label>
            <div class="input-group">
              <input id="cupom" type="text" class="form-control" placeholder="Insira o código aqui" v-model="pesquisa.ref_cupom" :disabled="cupomAdd"/>
              <div class="input-group-append">
                <button class="btn btn-primary btn-edit">{{cupomAdd ? 'Remover' : 'Aplicar'}}</button>
              </div>
            </div>
          </div>
          <hr>
        </form>
        <fidelidade componente="true" class="d-none" v-if="empresa.fidelidade"/>
        <div v-for="c in cupons" class="mb-3">
          <div class="card">
            <div class="card-body">
              <h5 class="font-weight-bold mb-0 text-dark">
                <icon name="cupom-sacola" size="20" class="text-primary mr-1" />
                {{c.ref_cupom}}
              </h5>
              <div class="small" v-if="c.tipo === '1'">
                Ganhe <b >{{c.valor | percent}}%</b> de desconto no valor {{c.modo_entrega ? 'da entrega' : 'dos produtos'}}
              </div>
              <div class="small" v-else>
                Ganhe <b>{{c.valor | valor}}</b> de desconto no valor {{c.modo_entrega ? 'da entrega' : 'do pedido'}}
              </div>
              <router-link :to="url + '/promocoes'" class="badge badge-dark mb-2" v-if="c.pontos > 0"><icon name="pontos" size="12" class="mr-1"/> Programa de Vantagens</router-link>
              <ul class="mb-0 mt-1 pl-2 small">
                <li v-if="c.horario_fim !== '23:59'">Disponível somente até às <b>{{c.horario_fim}}</b> <i class="fa fa-clock-o"></i></li>
                <li v-if="c.pontos > 0">Acumule {{c.pontos}} pontos e resgate esse cupom</li>
                <li v-if="c.pagamentos && c.pagamentos.length">
                  Válido para pagamento em: {{c.pagamentos.map(pag => pag.nome_pagamento).join(", ")}}
                </li>
                <li v-if="c.tabelas && c.tabelas.length">
                  <span v-if="c.modo_produto === '1'">Válido apenas para produtos selecionados<br></span>
                  <span v-if="c.modo_produto === '2'">Não válido para os seguintes produtos: </span>
                  <a href="javascript:" class="text-primary font-weight-bold" @click="produtosCupom(c)"><u>Ver produtos</u></a>
                </li>
                <li v-if="c.valor_minimo > 0">Válido para pedidos acima de <b>{{c.valor_minimo | valor}}</b> <span v-if="!c.modo_entrega">(somente produtos)</span></li>
                <li v-if="c.valor_maximo">Desconto limitado ao valor máximo de <b>{{c.valor_maximo | valor}}</b></li>
                <li v-if="c.limite_usuario === '1'">Limite de uso: 1 vez por usuário</li>
                <li v-if="c.tipo_delivery > 1">Válido apenas para <b>{{c.tipo_delivery === '2' ? 'Retirar no Local' : 'Entregas'}}</b></li>
                <li v-if="c.min_pedidos === '0' && c.max_pedidos === '0'">Válido apenas para o primeiro pedido.</li>
                <li v-else-if="c.min_pedidos > 0">Quantidade mínima de pedidos: {{c.min_pedidos}}</li>
                <li v-if="c.data_formatada !== '29/08/2100 - 00:00'">
                  Data de validade: <b>{{c.data_formatada}}</b> ou até atingir a quantidade de cupons disponíveis
                </li>
              </ul>
              <div class="mt-3" v-if="!readonly && saldo >= c.pontos">
                <button type="button" class="btn btn-primary btn-block" @click="adicionarCupom(c, true)">
                  <span v-if="c.pontos > 0">{{saldo < c.pontos ? ('Pontos restante: ' + (c.pontos - saldo)) : 'Resgatar Cupom'}}</span>
                  <span v-else>Adicionar cupom</span>
                </button>
              </div>
            </div>
            <div class="text-center small p-1 bg-light" v-if="readonly || saldo < c.pontos">
              {{saldo < c.pontos ? ('Pontos restante: ' + (c.pontos - saldo)) : 'Aplique o cupom na sacola'}}
            </div>
          </div>
        </div>
        <div class="text-center center" v-if="!load && cupons.length === 0">
          <div>
            <icon name="cupom" size="32" class="text-primary"/>
            <div class="mt-2 mb-0">Nenhum cupom encontrado</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CardInfo from './CardInfo'
  import TopBar from "./TopBar";
  import Loading from "./Loading";
  import Fidelidade from "../pages/Fidelidade";
  import Icon from "./Icon";

  export default {
    name: "Cupom",
    components: {Icon, Loading, TopBar, CardInfo, Fidelidade},
    props: ['dados', 'componente', 'readonly'],
    data() {
      return {
        token: localStorage.getItem('token'),
        opened: false,
        load: false,
        cupons: [],
        cupomAdd: false,
        tabelas: [],
        pesquisa: {
          token: localStorage.getItem('token'),
          ref_cupom: '',
          lecargo: false
        }
      }
    },

    methods: {
      getCupons(callback) {
        if (this.cupomAdd) {
          this.pesquisa.ref_cupom = '';
          this.cupomAdd = false;
        }

        this.load = true;
        this.tabelas = this.$helpers.getIdsSacola(this.dados);
        this.pesquisa.origin = this.origin;

        this.$http.get(this.$store.state.base_url + 'meus-cupons', {params: this.pesquisa})
          .then(response => {
            this.cupons = response.data;
            this.load = false;

            if (this.pesquisa.ref_cupom !== '') {
              this.cupomAdd = true;
            }

            if (callback) {
              callback();
            }

          }, res => {
            this.load = false;

            if (callback) {
              callback();
            }
          });
      },

      closeModal() {
        this.cupons = [];
        document.body.classList.remove("modal-open");
        this.opened = false;
      },

      selecionar(tipo) {
        this.opened = false;
        this.$store.state.sacola.tipo_pedido = tipo;
        localStorage.setItem('sacola', JSON.stringify(this.$store.state.sacola))
      },

      adicionarCupom(c, showMsg) {
        if (!this.componente && this.saldo >= c.pontos) {
          if (c.tabelas.length) {
            const existe = c.tabelas.some(t => this.tabelas.includes(t.id_tabela_preco));

            if ((c.modo_produto === '1' && !existe) || (c.modo_produto === '2' && existe)) {
              const produtos = c.tabelas.map(t => t.nome_produto);
              const modo_produto = c.modo_produto === '1' ? "INCLUA em" : "REMOVA da";
              this.$swal('Para utilizar este cupom de desconto, '+ modo_produto +' sua sacola um dos seguintes produtos: ' + produtos.join(" | "));
              return;
            }
          }

          if (c.tipo_delivery > 1 && ((this.dados.tipo_pedido == 1 && c.tipo_delivery === '2') || (this.dados.tipo_pedido == 2 && c.tipo_delivery === '3'))) {
            const tipo = this.dados.tipo_pedido == 1 ? "Retiradas no Local" : "Entregas";
            this.$swal('Este cupom é válido apenas para "' + tipo + '". Altere sua sacola para utilizar este cupom.');
            return;
          }

          this.$emit('adicionar', c, showMsg);
          this.closeModal();
        }
      },

      produtosCupom(c) {
        this.$swal(c.tabelas.map(t => t.nome_produto).join(" | "));
      },

      buscarCupons() {
        if (this.readonly && sessionStorage.getItem('cuponsReadonly')) {
          this.cupons = JSON.parse(sessionStorage.getItem('cuponsReadonly'));
          this.$emit('cuponsDisponiveis', this.cupons);

        } else {
          this.getCupons(() => {
            this.$emit('cuponsDisponiveis', this.cupons);

            if (this.componente) {
              sessionStorage.setItem('cuponsReadonly', JSON.stringify(this.cupons));
            }
          });
        }
      }
    },

    mounted() {
      if (this.componente) {
        this.opened = true;
        this.buscarCupons();
      }
    },

    created() {
      this.$parent.$on('openModalCupom', () => {
        document.body.classList.add("modal-open");
        this.opened = true;
        this.getCupons();
      });

      this.$parent.$on('buscarCupons', () => {
        this.buscarCupons();
      });
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      url() {
        return this.$store.state.url
      },

      cidade() {
        return this.$store.state.cidade
      },

      saldo() {
        return this.$store.state.saldoFidelidade
      }
    },
  }
</script>

<style scoped>
  .modal-cupom {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.5); /* Black w/ opacity */
  }

  .modal-cupom .modal-cupom-content {
    background-color: #fefefe;
    overflow: auto;
    margin: 48px auto;
    width: 500px;
    height: 75vh;
    position: relative;
    border-radius: 12px;
  }

  .center {
    height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 600px) {
    .modal-cupom .modal-cupom-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
    }
  }
</style>
